'use client';

import { memo } from 'react';

export type VideoPreviewProps = {
  src: string;
};

export const VideoPreview = memo(({ src }: VideoPreviewProps) => {
  // biome-ignore lint/a11y/useMediaCaption: Captions are not available for user-uploaded assets
  return <video className="size-full object-contain" controls src={src} />;
});

VideoPreview.displayName = 'VideoPreview';
